package com.lightningkite.kiteui.views

actual inline var FutureElementStyle.cssText: String?
    get() = native.cssText as? String 
    set(value) { native.cssText = value }
actual inline var FutureElementStyle.cssFloat: String?
    get() = native.cssFloat as? String 
    set(value) { native.cssFloat = value }
actual inline var FutureElementStyle.alignContent: String?
    get() = native.alignContent as? String 
    set(value) { native.alignContent = value }
actual inline var FutureElementStyle.alignItems: String?
    get() = native.alignItems as? String 
    set(value) { native.alignItems = value }
actual inline var FutureElementStyle.alignSelf: String?
    get() = native.alignSelf as? String 
    set(value) { native.alignSelf = value }
actual inline var FutureElementStyle.animation: String?
    get() = native.animation as? String 
    set(value) { native.animation = value }
actual inline var FutureElementStyle.animationDelay: String?
    get() = native.animationDelay as? String 
    set(value) { native.animationDelay = value }
actual inline var FutureElementStyle.animationDirection: String?
    get() = native.animationDirection as? String 
    set(value) { native.animationDirection = value }
actual inline var FutureElementStyle.animationDuration: String?
    get() = native.animationDuration as? String 
    set(value) { native.animationDuration = value }
actual inline var FutureElementStyle.animationFillMode: String?
    get() = native.animationFillMode as? String 
    set(value) { native.animationFillMode = value }
actual inline var FutureElementStyle.animationIterationCount: String?
    get() = native.animationIterationCount as? String 
    set(value) { native.animationIterationCount = value }
actual inline var FutureElementStyle.animationName: String?
    get() = native.animationName as? String 
    set(value) { native.animationName = value }
actual inline var FutureElementStyle.animationPlayState: String?
    get() = native.animationPlayState as? String 
    set(value) { native.animationPlayState = value }
actual inline var FutureElementStyle.animationTimingFunction: String?
    get() = native.animationTimingFunction as? String 
    set(value) { native.animationTimingFunction = value }
actual inline var FutureElementStyle.backfaceVisibility: String?
    get() = native.backfaceVisibility as? String 
    set(value) { native.backfaceVisibility = value }
actual inline var FutureElementStyle.background: String?
    get() = native.background as? String 
    set(value) { native.background = value }
actual inline var FutureElementStyle.backgroundAttachment: String?
    get() = native.backgroundAttachment as? String 
    set(value) { native.backgroundAttachment = value }
actual inline var FutureElementStyle.backgroundClip: String?
    get() = native.backgroundClip as? String 
    set(value) { native.backgroundClip = value }
actual inline var FutureElementStyle.backgroundColor: String?
    get() = native.backgroundColor as? String 
    set(value) { native.backgroundColor = value }
actual inline var FutureElementStyle.backgroundImage: String?
    get() = native.backgroundImage as? String 
    set(value) { native.backgroundImage = value }
actual inline var FutureElementStyle.backgroundOrigin: String?
    get() = native.backgroundOrigin as? String 
    set(value) { native.backgroundOrigin = value }
actual inline var FutureElementStyle.backgroundPosition: String?
    get() = native.backgroundPosition as? String 
    set(value) { native.backgroundPosition = value }
actual inline var FutureElementStyle.backgroundRepeat: String?
    get() = native.backgroundRepeat as? String 
    set(value) { native.backgroundRepeat = value }
actual inline var FutureElementStyle.backgroundSize: String?
    get() = native.backgroundSize as? String 
    set(value) { native.backgroundSize = value }
actual inline var FutureElementStyle.border: String?
    get() = native.border as? String 
    set(value) { native.border = value }
actual inline var FutureElementStyle.borderBottom: String?
    get() = native.borderBottom as? String 
    set(value) { native.borderBottom = value }
actual inline var FutureElementStyle.borderBottomColor: String?
    get() = native.borderBottomColor as? String 
    set(value) { native.borderBottomColor = value }
actual inline var FutureElementStyle.borderBottomLeftRadius: String?
    get() = native.borderBottomLeftRadius as? String 
    set(value) { native.borderBottomLeftRadius = value }
actual inline var FutureElementStyle.borderBottomRightRadius: String?
    get() = native.borderBottomRightRadius as? String 
    set(value) { native.borderBottomRightRadius = value }
actual inline var FutureElementStyle.borderBottomStyle: String?
    get() = native.borderBottomStyle as? String 
    set(value) { native.borderBottomStyle = value }
actual inline var FutureElementStyle.borderBottomWidth: String?
    get() = native.borderBottomWidth as? String 
    set(value) { native.borderBottomWidth = value }
actual inline var FutureElementStyle.borderCollapse: String?
    get() = native.borderCollapse as? String 
    set(value) { native.borderCollapse = value }
actual inline var FutureElementStyle.borderColor: String?
    get() = native.borderColor as? String 
    set(value) { native.borderColor = value }
actual inline var FutureElementStyle.borderImage: String?
    get() = native.borderImage as? String 
    set(value) { native.borderImage = value }
actual inline var FutureElementStyle.borderImageOutset: String?
    get() = native.borderImageOutset as? String 
    set(value) { native.borderImageOutset = value }
actual inline var FutureElementStyle.borderImageRepeat: String?
    get() = native.borderImageRepeat as? String 
    set(value) { native.borderImageRepeat = value }
actual inline var FutureElementStyle.borderImageSlice: String?
    get() = native.borderImageSlice as? String 
    set(value) { native.borderImageSlice = value }
actual inline var FutureElementStyle.borderImageSource: String?
    get() = native.borderImageSource as? String 
    set(value) { native.borderImageSource = value }
actual inline var FutureElementStyle.borderImageWidth: String?
    get() = native.borderImageWidth as? String 
    set(value) { native.borderImageWidth = value }
actual inline var FutureElementStyle.borderLeft: String?
    get() = native.borderLeft as? String 
    set(value) { native.borderLeft = value }
actual inline var FutureElementStyle.borderLeftColor: String?
    get() = native.borderLeftColor as? String 
    set(value) { native.borderLeftColor = value }
actual inline var FutureElementStyle.borderLeftStyle: String?
    get() = native.borderLeftStyle as? String 
    set(value) { native.borderLeftStyle = value }
actual inline var FutureElementStyle.borderLeftWidth: String?
    get() = native.borderLeftWidth as? String 
    set(value) { native.borderLeftWidth = value }
actual inline var FutureElementStyle.borderRadius: String?
    get() = native.borderRadius as? String 
    set(value) { native.borderRadius = value }
actual inline var FutureElementStyle.borderRight: String?
    get() = native.borderRight as? String 
    set(value) { native.borderRight = value }
actual inline var FutureElementStyle.borderRightColor: String?
    get() = native.borderRightColor as? String 
    set(value) { native.borderRightColor = value }
actual inline var FutureElementStyle.borderRightStyle: String?
    get() = native.borderRightStyle as? String 
    set(value) { native.borderRightStyle = value }
actual inline var FutureElementStyle.borderRightWidth: String?
    get() = native.borderRightWidth as? String 
    set(value) { native.borderRightWidth = value }
actual inline var FutureElementStyle.borderSpacing: String?
    get() = native.borderSpacing as? String 
    set(value) { native.borderSpacing = value }
actual inline var FutureElementStyle.borderStyle: String?
    get() = native.borderStyle as? String 
    set(value) { native.borderStyle = value }
actual inline var FutureElementStyle.borderTop: String?
    get() = native.borderTop as? String 
    set(value) { native.borderTop = value }
actual inline var FutureElementStyle.borderTopColor: String?
    get() = native.borderTopColor as? String 
    set(value) { native.borderTopColor = value }
actual inline var FutureElementStyle.borderTopLeftRadius: String?
    get() = native.borderTopLeftRadius as? String 
    set(value) { native.borderTopLeftRadius = value }
actual inline var FutureElementStyle.borderTopRightRadius: String?
    get() = native.borderTopRightRadius as? String 
    set(value) { native.borderTopRightRadius = value }
actual inline var FutureElementStyle.borderTopStyle: String?
    get() = native.borderTopStyle as? String 
    set(value) { native.borderTopStyle = value }
actual inline var FutureElementStyle.borderTopWidth: String?
    get() = native.borderTopWidth as? String 
    set(value) { native.borderTopWidth = value }
actual inline var FutureElementStyle.borderWidth: String?
    get() = native.borderWidth as? String 
    set(value) { native.borderWidth = value }
actual inline var FutureElementStyle.bottom: String?
    get() = native.bottom as? String 
    set(value) { native.bottom = value }
actual inline var FutureElementStyle.boxDecorationBreak: String?
    get() = native.boxDecorationBreak as? String 
    set(value) { native.boxDecorationBreak = value }
actual inline var FutureElementStyle.boxShadow: String?
    get() = native.boxShadow as? String 
    set(value) { native.boxShadow = value }
actual inline var FutureElementStyle.boxSizing: String?
    get() = native.boxSizing as? String 
    set(value) { native.boxSizing = value }
actual inline var FutureElementStyle.breakAfter: String?
    get() = native.breakAfter as? String 
    set(value) { native.breakAfter = value }
actual inline var FutureElementStyle.breakBefore: String?
    get() = native.breakBefore as? String 
    set(value) { native.breakBefore = value }
actual inline var FutureElementStyle.breakInside: String?
    get() = native.breakInside as? String 
    set(value) { native.breakInside = value }
actual inline var FutureElementStyle.captionSide: String?
    get() = native.captionSide as? String 
    set(value) { native.captionSide = value }
actual inline var FutureElementStyle.clear: String?
    get() = native.clear as? String 
    set(value) { native.clear = value }
actual inline var FutureElementStyle.clip: String?
    get() = native.clip as? String 
    set(value) { native.clip = value }
actual inline var FutureElementStyle.color: String?
    get() = native.color as? String 
    set(value) { native.color = value }
actual inline var FutureElementStyle.columnCount: String?
    get() = native.columnCount as? String 
    set(value) { native.columnCount = value }
actual inline var FutureElementStyle.columnFill: String?
    get() = native.columnFill as? String 
    set(value) { native.columnFill = value }
actual inline var FutureElementStyle.columnGap: String?
    get() = native.columnGap as? String 
    set(value) { native.columnGap = value }
actual inline var FutureElementStyle.columnRule: String?
    get() = native.columnRule as? String 
    set(value) { native.columnRule = value }
actual inline var FutureElementStyle.columnRuleColor: String?
    get() = native.columnRuleColor as? String 
    set(value) { native.columnRuleColor = value }
actual inline var FutureElementStyle.columnRuleStyle: String?
    get() = native.columnRuleStyle as? String 
    set(value) { native.columnRuleStyle = value }
actual inline var FutureElementStyle.columnRuleWidth: String?
    get() = native.columnRuleWidth as? String 
    set(value) { native.columnRuleWidth = value }
actual inline var FutureElementStyle.columnSpan: String?
    get() = native.columnSpan as? String 
    set(value) { native.columnSpan = value }
actual inline var FutureElementStyle.columnWidth: String?
    get() = native.columnWidth as? String 
    set(value) { native.columnWidth = value }
actual inline var FutureElementStyle.columns: String?
    get() = native.columns as? String 
    set(value) { native.columns = value }
actual inline var FutureElementStyle.content: String?
    get() = native.content as? String 
    set(value) { native.content = value }
actual inline var FutureElementStyle.counterIncrement: String?
    get() = native.counterIncrement as? String 
    set(value) { native.counterIncrement = value }
actual inline var FutureElementStyle.counterReset: String?
    get() = native.counterReset as? String 
    set(value) { native.counterReset = value }
actual inline var FutureElementStyle.cursor: String?
    get() = native.cursor as? String 
    set(value) { native.cursor = value }
actual inline var FutureElementStyle.direction: String?
    get() = native.direction as? String 
    set(value) { native.direction = value }
actual inline var FutureElementStyle.display: String?
    get() = native.display as? String 
    set(value) { native.display = value }
actual inline var FutureElementStyle.emptyCells: String?
    get() = native.emptyCells as? String 
    set(value) { native.emptyCells = value }
actual inline var FutureElementStyle.filter: String?
    get() = native.filter as? String 
    set(value) { native.filter = value }
actual inline var FutureElementStyle.flex: String?
    get() = native.flex as? String 
    set(value) { native.flex = value }
actual inline var FutureElementStyle.flexBasis: String?
    get() = native.flexBasis as? String 
    set(value) { native.flexBasis = value }
actual inline var FutureElementStyle.flexDirection: String?
    get() = native.flexDirection as? String 
    set(value) { native.flexDirection = value }
actual inline var FutureElementStyle.flexFlow: String?
    get() = native.flexFlow as? String 
    set(value) { native.flexFlow = value }
actual inline var FutureElementStyle.flexGrow: String?
    get() = native.flexGrow as? String 
    set(value) { native.flexGrow = value }
actual inline var FutureElementStyle.flexShrink: String?
    get() = native.flexShrink as? String 
    set(value) { native.flexShrink = value }
actual inline var FutureElementStyle.flexWrap: String?
    get() = native.flexWrap as? String 
    set(value) { native.flexWrap = value }
actual inline var FutureElementStyle.font: String?
    get() = native.font as? String 
    set(value) { native.font = value }
actual inline var FutureElementStyle.fontFamily: String?
    get() = native.fontFamily as? String 
    set(value) { native.fontFamily = value }
actual inline var FutureElementStyle.fontFeatureSettings: String?
    get() = native.fontFeatureSettings as? String 
    set(value) { native.fontFeatureSettings = value }
actual inline var FutureElementStyle.fontKerning: String?
    get() = native.fontKerning as? String 
    set(value) { native.fontKerning = value }
actual inline var FutureElementStyle.fontLanguageOverride: String?
    get() = native.fontLanguageOverride as? String 
    set(value) { native.fontLanguageOverride = value }
actual inline var FutureElementStyle.fontSize: String?
    get() = native.fontSize as? String 
    set(value) { native.fontSize = value }
actual inline var FutureElementStyle.fontSizeAdjust: String?
    get() = native.fontSizeAdjust as? String 
    set(value) { native.fontSizeAdjust = value }
actual inline var FutureElementStyle.fontStretch: String?
    get() = native.fontStretch as? String 
    set(value) { native.fontStretch = value }
actual inline var FutureElementStyle.fontStyle: String?
    get() = native.fontStyle as? String 
    set(value) { native.fontStyle = value }
actual inline var FutureElementStyle.fontSynthesis: String?
    get() = native.fontSynthesis as? String 
    set(value) { native.fontSynthesis = value }
actual inline var FutureElementStyle.fontVariant: String?
    get() = native.fontVariant as? String 
    set(value) { native.fontVariant = value }
actual inline var FutureElementStyle.fontVariantAlternates: String?
    get() = native.fontVariantAlternates as? String 
    set(value) { native.fontVariantAlternates = value }
actual inline var FutureElementStyle.fontVariantCaps: String?
    get() = native.fontVariantCaps as? String 
    set(value) { native.fontVariantCaps = value }
actual inline var FutureElementStyle.fontVariantEastAsian: String?
    get() = native.fontVariantEastAsian as? String 
    set(value) { native.fontVariantEastAsian = value }
actual inline var FutureElementStyle.fontVariantLigatures: String?
    get() = native.fontVariantLigatures as? String 
    set(value) { native.fontVariantLigatures = value }
actual inline var FutureElementStyle.fontVariantNumeric: String?
    get() = native.fontVariantNumeric as? String 
    set(value) { native.fontVariantNumeric = value }
actual inline var FutureElementStyle.fontVariantPosition: String?
    get() = native.fontVariantPosition as? String 
    set(value) { native.fontVariantPosition = value }
actual inline var FutureElementStyle.fontWeight: String?
    get() = native.fontWeight as? String 
    set(value) { native.fontWeight = value }
actual inline var FutureElementStyle.hangingPunctuation: String?
    get() = native.hangingPunctuation as? String 
    set(value) { native.hangingPunctuation = value }
actual inline var FutureElementStyle.height: String?
    get() = native.height as? String 
    set(value) { native.height = value }
actual inline var FutureElementStyle.hyphens: String?
    get() = native.hyphens as? String 
    set(value) { native.hyphens = value }
actual inline var FutureElementStyle.imageOrientation: String?
    get() = native.imageOrientation as? String 
    set(value) { native.imageOrientation = value }
actual inline var FutureElementStyle.imageRendering: String?
    get() = native.imageRendering as? String 
    set(value) { native.imageRendering = value }
actual inline var FutureElementStyle.imageResolution: String?
    get() = native.imageResolution as? String 
    set(value) { native.imageResolution = value }
actual inline var FutureElementStyle.imeMode: String?
    get() = native.imeMode as? String 
    set(value) { native.imeMode = value }
actual inline var FutureElementStyle.justifySelf: String?
    get() = native.justifySelf as? String
    set(value) { native.justifySelf = value }
actual inline var FutureElementStyle.justifyContent: String?
    get() = native.justifyContent as? String 
    set(value) { native.justifyContent = value }
actual inline var FutureElementStyle.left: String?
    get() = native.left as? String 
    set(value) { native.left = value }
actual inline var FutureElementStyle.letterSpacing: String?
    get() = native.letterSpacing as? String 
    set(value) { native.letterSpacing = value }
actual inline var FutureElementStyle.lineBreak: String?
    get() = native.lineBreak as? String 
    set(value) { native.lineBreak = value }
actual inline var FutureElementStyle.lineHeight: String?
    get() = native.lineHeight as? String 
    set(value) { native.lineHeight = value }
actual inline var FutureElementStyle.listStyle: String?
    get() = native.listStyle as? String 
    set(value) { native.listStyle = value }
actual inline var FutureElementStyle.listStyleImage: String?
    get() = native.listStyleImage as? String 
    set(value) { native.listStyleImage = value }
actual inline var FutureElementStyle.listStylePosition: String?
    get() = native.listStylePosition as? String 
    set(value) { native.listStylePosition = value }
actual inline var FutureElementStyle.listStyleType: String?
    get() = native.listStyleType as? String 
    set(value) { native.listStyleType = value }
actual inline var FutureElementStyle.margin: String?
    get() = native.margin as? String 
    set(value) { native.margin = value }
actual inline var FutureElementStyle.marginBottom: String?
    get() = native.marginBottom as? String 
    set(value) { native.marginBottom = value }
actual inline var FutureElementStyle.marginLeft: String?
    get() = native.marginLeft as? String 
    set(value) { native.marginLeft = value }
actual inline var FutureElementStyle.marginRight: String?
    get() = native.marginRight as? String 
    set(value) { native.marginRight = value }
actual inline var FutureElementStyle.marginTop: String?
    get() = native.marginTop as? String 
    set(value) { native.marginTop = value }
actual inline var FutureElementStyle.mark: String?
    get() = native.mark as? String 
    set(value) { native.mark = value }
actual inline var FutureElementStyle.markAfter: String?
    get() = native.markAfter as? String 
    set(value) { native.markAfter = value }
actual inline var FutureElementStyle.markBefore: String?
    get() = native.markBefore as? String 
    set(value) { native.markBefore = value }
actual inline var FutureElementStyle.marks: String?
    get() = native.marks as? String 
    set(value) { native.marks = value }
actual inline var FutureElementStyle.marqueeDirection: String?
    get() = native.marqueeDirection as? String 
    set(value) { native.marqueeDirection = value }
actual inline var FutureElementStyle.marqueePlayCount: String?
    get() = native.marqueePlayCount as? String 
    set(value) { native.marqueePlayCount = value }
actual inline var FutureElementStyle.marqueeSpeed: String?
    get() = native.marqueeSpeed as? String 
    set(value) { native.marqueeSpeed = value }
actual inline var FutureElementStyle.marqueeStyle: String?
    get() = native.marqueeStyle as? String 
    set(value) { native.marqueeStyle = value }
actual inline var FutureElementStyle.mask: String?
    get() = native.mask as? String 
    set(value) { native.mask = value }
actual inline var FutureElementStyle.maskType: String?
    get() = native.maskType as? String 
    set(value) { native.maskType = value }
actual inline var FutureElementStyle.maxHeight: String?
    get() = native.maxHeight as? String 
    set(value) { native.maxHeight = value }
actual inline var FutureElementStyle.maxWidth: String?
    get() = native.maxWidth as? String 
    set(value) { native.maxWidth = value }
actual inline var FutureElementStyle.minHeight: String?
    get() = native.minHeight as? String 
    set(value) { native.minHeight = value }
actual inline var FutureElementStyle.minWidth: String?
    get() = native.minWidth as? String 
    set(value) { native.minWidth = value }
actual inline var FutureElementStyle.navDown: String?
    get() = native.navDown as? String 
    set(value) { native.navDown = value }
actual inline var FutureElementStyle.navIndex: String?
    get() = native.navIndex as? String 
    set(value) { native.navIndex = value }
actual inline var FutureElementStyle.navLeft: String?
    get() = native.navLeft as? String 
    set(value) { native.navLeft = value }
actual inline var FutureElementStyle.navRight: String?
    get() = native.navRight as? String 
    set(value) { native.navRight = value }
actual inline var FutureElementStyle.navUp: String?
    get() = native.navUp as? String 
    set(value) { native.navUp = value }
actual inline var FutureElementStyle.objectFit: String?
    get() = native.objectFit as? String 
    set(value) { native.objectFit = value }
actual inline var FutureElementStyle.objectPosition: String?
    get() = native.objectPosition as? String 
    set(value) { native.objectPosition = value }
actual inline var FutureElementStyle.opacity: String?
    get() = native.opacity as? String 
    set(value) { native.opacity = value }
actual inline var FutureElementStyle.order: String?
    get() = native.order as? String 
    set(value) { native.order = value }
actual inline var FutureElementStyle.orphans: String?
    get() = native.orphans as? String 
    set(value) { native.orphans = value }
actual inline var FutureElementStyle.outline: String?
    get() = native.outline as? String 
    set(value) { native.outline = value }
actual inline var FutureElementStyle.outlineColor: String?
    get() = native.outlineColor as? String 
    set(value) { native.outlineColor = value }
actual inline var FutureElementStyle.outlineOffset: String?
    get() = native.outlineOffset as? String 
    set(value) { native.outlineOffset = value }
actual inline var FutureElementStyle.outlineStyle: String?
    get() = native.outlineStyle as? String 
    set(value) { native.outlineStyle = value }
actual inline var FutureElementStyle.outlineWidth: String?
    get() = native.outlineWidth as? String 
    set(value) { native.outlineWidth = value }
actual inline var FutureElementStyle.overflowAnchor: String?
    get() = native.overflowAnchor as? String
    set(value) { native.overflowAnchor = value }
actual inline var FutureElementStyle.overflowWrap: String?
    get() = native.overflowWrap as? String
    set(value) { native.overflowWrap = value }
actual inline var FutureElementStyle.overflowX: String?
    get() = native.overflowX as? String 
    set(value) { native.overflowX = value }
actual inline var FutureElementStyle.overflowY: String?
    get() = native.overflowY as? String 
    set(value) { native.overflowY = value }
actual inline var FutureElementStyle.padding: String?
    get() = native.padding as? String 
    set(value) { native.padding = value }
actual inline var FutureElementStyle.paddingBottom: String?
    get() = native.paddingBottom as? String 
    set(value) { native.paddingBottom = value }
actual inline var FutureElementStyle.paddingLeft: String?
    get() = native.paddingLeft as? String 
    set(value) { native.paddingLeft = value }
actual inline var FutureElementStyle.paddingRight: String?
    get() = native.paddingRight as? String 
    set(value) { native.paddingRight = value }
actual inline var FutureElementStyle.paddingTop: String?
    get() = native.paddingTop as? String 
    set(value) { native.paddingTop = value }
actual inline var FutureElementStyle.pageBreakAfter: String?
    get() = native.pageBreakAfter as? String 
    set(value) { native.pageBreakAfter = value }
actual inline var FutureElementStyle.pageBreakBefore: String?
    get() = native.pageBreakBefore as? String 
    set(value) { native.pageBreakBefore = value }
actual inline var FutureElementStyle.pageBreakInside: String?
    get() = native.pageBreakInside as? String 
    set(value) { native.pageBreakInside = value }
actual inline var FutureElementStyle.perspective: String?
    get() = native.perspective as? String 
    set(value) { native.perspective = value }
actual inline var FutureElementStyle.perspectiveOrigin: String?
    get() = native.perspectiveOrigin as? String 
    set(value) { native.perspectiveOrigin = value }
actual inline var FutureElementStyle.phonemes: String?
    get() = native.phonemes as? String 
    set(value) { native.phonemes = value }
actual inline var FutureElementStyle.position: String?
    get() = native.position as? String 
    set(value) { native.position = value }
actual inline var FutureElementStyle.quotes: String?
    get() = native.quotes as? String 
    set(value) { native.quotes = value }
actual inline var FutureElementStyle.resize: String?
    get() = native.resize as? String 
    set(value) { native.resize = value }
actual inline var FutureElementStyle.rest: String?
    get() = native.rest as? String 
    set(value) { native.rest = value }
actual inline var FutureElementStyle.restAfter: String?
    get() = native.restAfter as? String 
    set(value) { native.restAfter = value }
actual inline var FutureElementStyle.restBefore: String?
    get() = native.restBefore as? String 
    set(value) { native.restBefore = value }
actual inline var FutureElementStyle.right: String?
    get() = native.right as? String 
    set(value) { native.right = value }
actual inline var FutureElementStyle.tabSize: String?
    get() = native.tabSize as? String 
    set(value) { native.tabSize = value }
actual inline var FutureElementStyle.tableLayout: String?
    get() = native.tableLayout as? String 
    set(value) { native.tableLayout = value }
actual inline var FutureElementStyle.textAlign: String?
    get() = native.textAlign as? String 
    set(value) { native.textAlign = value }
actual inline var FutureElementStyle.textAlignLast: String?
    get() = native.textAlignLast as? String 
    set(value) { native.textAlignLast = value }
actual inline var FutureElementStyle.textCombineUpright: String?
    get() = native.textCombineUpright as? String 
    set(value) { native.textCombineUpright = value }
actual inline var FutureElementStyle.textDecoration: String?
    get() = native.textDecoration as? String 
    set(value) { native.textDecoration = value }
actual inline var FutureElementStyle.textDecorationColor: String?
    get() = native.textDecorationColor as? String 
    set(value) { native.textDecorationColor = value }
actual inline var FutureElementStyle.textDecorationLine: String?
    get() = native.textDecorationLine as? String 
    set(value) { native.textDecorationLine = value }
actual inline var FutureElementStyle.textDecorationStyle: String?
    get() = native.textDecorationStyle as? String 
    set(value) { native.textDecorationStyle = value }
actual inline var FutureElementStyle.textIndent: String?
    get() = native.textIndent as? String 
    set(value) { native.textIndent = value }
actual inline var FutureElementStyle.textJustify: String?
    get() = native.textJustify as? String 
    set(value) { native.textJustify = value }
actual inline var FutureElementStyle.textOrientation: String?
    get() = native.textOrientation as? String 
    set(value) { native.textOrientation = value }
actual inline var FutureElementStyle.textOverflow: String?
    get() = native.textOverflow as? String 
    set(value) { native.textOverflow = value }
actual inline var FutureElementStyle.textShadow: String?
    get() = native.textShadow as? String 
    set(value) { native.textShadow = value }
actual inline var FutureElementStyle.textTransform: String?
    get() = native.textTransform as? String 
    set(value) { native.textTransform = value }
actual inline var FutureElementStyle.textUnderlinePosition: String?
    get() = native.textUnderlinePosition as? String 
    set(value) { native.textUnderlinePosition = value }
actual inline var FutureElementStyle.top: String?
    get() = native.top as? String 
    set(value) { native.top = value }
actual inline var FutureElementStyle.transform: String?
    get() = native.transform as? String 
    set(value) { native.transform = value }
actual inline var FutureElementStyle.transformOrigin: String?
    get() = native.transformOrigin as? String 
    set(value) { native.transformOrigin = value }
actual inline var FutureElementStyle.transformStyle: String?
    get() = native.transformStyle as? String 
    set(value) { native.transformStyle = value }
actual inline var FutureElementStyle.transition: String?
    get() = native.transition as? String 
    set(value) { native.transition = value }
actual inline var FutureElementStyle.transitionDelay: String?
    get() = native.transitionDelay as? String 
    set(value) { native.transitionDelay = value }
actual inline var FutureElementStyle.transitionDuration: String?
    get() = native.transitionDuration as? String 
    set(value) { native.transitionDuration = value }
actual inline var FutureElementStyle.transitionProperty: String?
    get() = native.transitionProperty as? String 
    set(value) { native.transitionProperty = value }
actual inline var FutureElementStyle.transitionTimingFunction: String?
    get() = native.transitionTimingFunction as? String 
    set(value) { native.transitionTimingFunction = value }
actual inline var FutureElementStyle.unicodeBidi: String?
    get() = native.unicodeBidi as? String 
    set(value) { native.unicodeBidi = value }
actual inline var FutureElementStyle.verticalAlign: String?
    get() = native.verticalAlign as? String 
    set(value) { native.verticalAlign = value }
actual inline var FutureElementStyle.visibility: String?
    get() = native.visibility as? String 
    set(value) { native.visibility = value }
actual inline var FutureElementStyle.voiceBalance: String?
    get() = native.voiceBalance as? String 
    set(value) { native.voiceBalance = value }
actual inline var FutureElementStyle.voiceDuration: String?
    get() = native.voiceDuration as? String 
    set(value) { native.voiceDuration = value }
actual inline var FutureElementStyle.voicePitch: String?
    get() = native.voicePitch as? String 
    set(value) { native.voicePitch = value }
actual inline var FutureElementStyle.voicePitchRange: String?
    get() = native.voicePitchRange as? String 
    set(value) { native.voicePitchRange = value }
actual inline var FutureElementStyle.voiceRate: String?
    get() = native.voiceRate as? String 
    set(value) { native.voiceRate = value }
actual inline var FutureElementStyle.voiceStress: String?
    get() = native.voiceStress as? String 
    set(value) { native.voiceStress = value }
actual inline var FutureElementStyle.voiceVolume: String?
    get() = native.voiceVolume as? String 
    set(value) { native.voiceVolume = value }
actual inline var FutureElementStyle.whiteSpace: String?
    get() = native.whiteSpace as? String 
    set(value) { native.whiteSpace = value }
actual inline var FutureElementStyle.widows: String?
    get() = native.widows as? String 
    set(value) { native.widows = value }
actual inline var FutureElementStyle.width: String?
    get() = native.width as? String 
    set(value) { native.width = value }
actual inline var FutureElementStyle.wordBreak: String?
    get() = native.wordBreak as? String 
    set(value) { native.wordBreak = value }
actual inline var FutureElementStyle.wordSpacing: String?
    get() = native.wordSpacing as? String 
    set(value) { native.wordSpacing = value }
actual inline var FutureElementStyle.wordWrap: String?
    get() = native.wordWrap as? String 
    set(value) { native.wordWrap = value }
actual inline var FutureElementStyle.writingMode: String?
    get() = native.writingMode as? String 
    set(value) { native.writingMode = value }
actual inline var FutureElementStyle.zIndex: String?
    get() = native.zIndex as? String 
    set(value) { native.zIndex = value }
actual inline var FutureElementAttributes.accept: String?
    get() = native.accept as? String
    set(value) { native.accept = value }
actual inline var FutureElementAttributes.acceptCharset: String?
    get() = native.acceptCharset as? String
    set(value) { native.acceptCharset = value }
actual inline var FutureElementAttributes.accessKey: String?
    get() = native.accessKey as? String
    set(value) { native.accessKey = value }
actual inline var FutureElementAttributes.action: String?
    get() = native.action as? String
    set(value) { native.action = value }
actual inline var FutureElementAttributes.align: String?
    get() = native.align as? String
    set(value) { native.align = value }
actual inline var FutureElementAttributes.alignContent: String?
    get() = native.alignContent as? String
    set(value) { native.alignContent = value }
actual inline var FutureElementAttributes.alignItems: String?
    get() = native.alignItems as? String
    set(value) { native.alignItems = value }
actual inline var FutureElementAttributes.alignSelf: String?
    get() = native.alignSelf as? String
    set(value) { native.alignSelf = value }
actual inline var FutureElementAttributes.allow: String?
    get() = native.allow as? String
    set(value) { native.allow = value }
actual inline var FutureElementAttributes.alt: String?
    get() = native.alt as? String
    set(value) { native.alt = value }
actual inline var FutureElementAttributes.animation: String?
    get() = native.animation as? String
    set(value) { native.animation = value }
actual inline var FutureElementAttributes.animationDelay: String?
    get() = native.animationDelay as? String
    set(value) { native.animationDelay = value }
actual inline var FutureElementAttributes.animationDirection: String?
    get() = native.animationDirection as? String
    set(value) { native.animationDirection = value }
actual inline var FutureElementAttributes.animationDuration: String?
    get() = native.animationDuration as? String
    set(value) { native.animationDuration = value }
actual inline var FutureElementAttributes.animationFillMode: String?
    get() = native.animationFillMode as? String
    set(value) { native.animationFillMode = value }
actual inline var FutureElementAttributes.animationIterationCount: String?
    get() = native.animationIterationCount as? String
    set(value) { native.animationIterationCount = value }
actual inline var FutureElementAttributes.animationName: String?
    get() = native.animationName as? String
    set(value) { native.animationName = value }
actual inline var FutureElementAttributes.animationPlayState: String?
    get() = native.animationPlayState as? String
    set(value) { native.animationPlayState = value }
actual inline var FutureElementAttributes.animationTimingFunction: String?
    get() = native.animationTimingFunction as? String
    set(value) { native.animationTimingFunction = value }
actual inline var FutureElementAttributes.async: Boolean?
    get() = native.async as? Boolean
    set(value) { native.async = value }
actual inline var FutureElementAttributes.autocomplete: String?
    get() = native.autocomplete as? String
    set(value) { native.autocomplete = value }
actual inline var FutureElementAttributes.autofocusBoolean: Boolean?
    get() = native.autofocus as? Boolean
    set(value) { native.autofocus = value }
actual inline var FutureElementAttributes.autofocusString: String?
    get() = native.autofocus as? String
    set(value) { native.autofocus = value }
actual inline var FutureElementAttributes.autoplay: Boolean?
    get() = native.autoplay as? Boolean
    set(value) { native.autoplay = value }
actual inline var FutureElementAttributes.backfaceVisibility: String?
    get() = native.backfaceVisibility as? String
    set(value) { native.backfaceVisibility = value }
actual inline var FutureElementAttributes.background: String?
    get() = native.background as? String
    set(value) { native.background = value }
actual inline var FutureElementAttributes.backgroundAttachment: String?
    get() = native.backgroundAttachment as? String
    set(value) { native.backgroundAttachment = value }
actual inline var FutureElementAttributes.backgroundClip: String?
    get() = native.backgroundClip as? String
    set(value) { native.backgroundClip = value }
actual inline var FutureElementAttributes.backgroundColor: String?
    get() = native.backgroundColor as? String
    set(value) { native.backgroundColor = value }
actual inline var FutureElementAttributes.backgroundImage: String?
    get() = native.backgroundImage as? String
    set(value) { native.backgroundImage = value }
actual inline var FutureElementAttributes.backgroundOrigin: String?
    get() = native.backgroundOrigin as? String
    set(value) { native.backgroundOrigin = value }
actual inline var FutureElementAttributes.backgroundPosition: String?
    get() = native.backgroundPosition as? String
    set(value) { native.backgroundPosition = value }
actual inline var FutureElementAttributes.backgroundRepeat: String?
    get() = native.backgroundRepeat as? String
    set(value) { native.backgroundRepeat = value }
actual inline var FutureElementAttributes.backgroundSize: String?
    get() = native.backgroundSize as? String
    set(value) { native.backgroundSize = value }
actual inline var FutureElementAttributes.bgColor: String?
    get() = native.bgColor as? String
    set(value) { native.bgColor = value }
actual inline var FutureElementAttributes.border: String?
    get() = native.border as? String
    set(value) { native.border = value }
actual inline var FutureElementAttributes.borderBottom: String?
    get() = native.borderBottom as? String
    set(value) { native.borderBottom = value }
actual inline var FutureElementAttributes.borderBottomColor: String?
    get() = native.borderBottomColor as? String
    set(value) { native.borderBottomColor = value }
actual inline var FutureElementAttributes.borderBottomLeftRadius: String?
    get() = native.borderBottomLeftRadius as? String
    set(value) { native.borderBottomLeftRadius = value }
actual inline var FutureElementAttributes.borderBottomRightRadius: String?
    get() = native.borderBottomRightRadius as? String
    set(value) { native.borderBottomRightRadius = value }
actual inline var FutureElementAttributes.borderBottomStyle: String?
    get() = native.borderBottomStyle as? String
    set(value) { native.borderBottomStyle = value }
actual inline var FutureElementAttributes.borderBottomWidth: String?
    get() = native.borderBottomWidth as? String
    set(value) { native.borderBottomWidth = value }
actual inline var FutureElementAttributes.borderCollapse: String?
    get() = native.borderCollapse as? String
    set(value) { native.borderCollapse = value }
actual inline var FutureElementAttributes.borderColor: String?
    get() = native.borderColor as? String
    set(value) { native.borderColor = value }
actual inline var FutureElementAttributes.borderImage: String?
    get() = native.borderImage as? String
    set(value) { native.borderImage = value }
actual inline var FutureElementAttributes.borderImageOutset: String?
    get() = native.borderImageOutset as? String
    set(value) { native.borderImageOutset = value }
actual inline var FutureElementAttributes.borderImageRepeat: String?
    get() = native.borderImageRepeat as? String
    set(value) { native.borderImageRepeat = value }
actual inline var FutureElementAttributes.borderImageSlice: String?
    get() = native.borderImageSlice as? String
    set(value) { native.borderImageSlice = value }
actual inline var FutureElementAttributes.borderImageSource: String?
    get() = native.borderImageSource as? String
    set(value) { native.borderImageSource = value }
actual inline var FutureElementAttributes.borderImageWidth: String?
    get() = native.borderImageWidth as? String
    set(value) { native.borderImageWidth = value }
actual inline var FutureElementAttributes.borderLeft: String?
    get() = native.borderLeft as? String
    set(value) { native.borderLeft = value }
actual inline var FutureElementAttributes.borderLeftColor: String?
    get() = native.borderLeftColor as? String
    set(value) { native.borderLeftColor = value }
actual inline var FutureElementAttributes.borderLeftStyle: String?
    get() = native.borderLeftStyle as? String
    set(value) { native.borderLeftStyle = value }
actual inline var FutureElementAttributes.borderLeftWidth: String?
    get() = native.borderLeftWidth as? String
    set(value) { native.borderLeftWidth = value }
actual inline var FutureElementAttributes.borderRadius: String?
    get() = native.borderRadius as? String
    set(value) { native.borderRadius = value }
actual inline var FutureElementAttributes.borderRight: String?
    get() = native.borderRight as? String
    set(value) { native.borderRight = value }
actual inline var FutureElementAttributes.borderRightColor: String?
    get() = native.borderRightColor as? String
    set(value) { native.borderRightColor = value }
actual inline var FutureElementAttributes.borderRightStyle: String?
    get() = native.borderRightStyle as? String
    set(value) { native.borderRightStyle = value }
actual inline var FutureElementAttributes.borderRightWidth: String?
    get() = native.borderRightWidth as? String
    set(value) { native.borderRightWidth = value }
actual inline var FutureElementAttributes.borderSpacing: String?
    get() = native.borderSpacing as? String
    set(value) { native.borderSpacing = value }
actual inline var FutureElementAttributes.borderStyle: String?
    get() = native.borderStyle as? String
    set(value) { native.borderStyle = value }
actual inline var FutureElementAttributes.borderTop: String?
    get() = native.borderTop as? String
    set(value) { native.borderTop = value }
actual inline var FutureElementAttributes.borderTopColor: String?
    get() = native.borderTopColor as? String
    set(value) { native.borderTopColor = value }
actual inline var FutureElementAttributes.borderTopLeftRadius: String?
    get() = native.borderTopLeftRadius as? String
    set(value) { native.borderTopLeftRadius = value }
actual inline var FutureElementAttributes.borderTopRightRadius: String?
    get() = native.borderTopRightRadius as? String
    set(value) { native.borderTopRightRadius = value }
actual inline var FutureElementAttributes.borderTopStyle: String?
    get() = native.borderTopStyle as? String
    set(value) { native.borderTopStyle = value }
actual inline var FutureElementAttributes.borderTopWidth: String?
    get() = native.borderTopWidth as? String
    set(value) { native.borderTopWidth = value }
actual inline var FutureElementAttributes.borderWidth: String?
    get() = native.borderWidth as? String
    set(value) { native.borderWidth = value }
actual inline var FutureElementAttributes.bottom: String?
    get() = native.bottom as? String
    set(value) { native.bottom = value }
actual inline var FutureElementAttributes.boxDecorationBreak: String?
    get() = native.boxDecorationBreak as? String
    set(value) { native.boxDecorationBreak = value }
actual inline var FutureElementAttributes.boxShadow: String?
    get() = native.boxShadow as? String
    set(value) { native.boxShadow = value }
actual inline var FutureElementAttributes.boxSizing: String?
    get() = native.boxSizing as? String
    set(value) { native.boxSizing = value }
actual inline var FutureElementAttributes.breakAfter: String?
    get() = native.breakAfter as? String
    set(value) { native.breakAfter = value }
actual inline var FutureElementAttributes.breakBefore: String?
    get() = native.breakBefore as? String
    set(value) { native.breakBefore = value }
actual inline var FutureElementAttributes.breakInside: String?
    get() = native.breakInside as? String
    set(value) { native.breakInside = value }
actual inline var FutureElementAttributes.buffered: String?
    get() = native.buffered as? String
    set(value) { native.buffered = value }
actual inline var FutureElementAttributes.captionSide: String?
    get() = native.captionSide as? String
    set(value) { native.captionSide = value }
actual inline var FutureElementAttributes.challenge: String?
    get() = native.challenge as? String
    set(value) { native.challenge = value }
actual inline var FutureElementAttributes.charset: String?
    get() = native.charset as? String
    set(value) { native.charset = value }
actual inline var FutureElementAttributes.checked: Boolean?
    get() = native.checked as? Boolean
    set(value) { native.checked = value }
actual inline var FutureElementAttributes.cite: String?
    get() = native.cite as? String
    set(value) { native.cite = value }
actual inline var FutureElementAttributes.className: String?
    get() = native.className as? String
    set(value) { native.className = value }
actual inline var FutureElementAttributes.clear: String?
    get() = native.clear as? String
    set(value) { native.clear = value }
actual inline var FutureElementAttributes.clip: String?
    get() = native.clip as? String
    set(value) { native.clip = value }
actual inline var FutureElementAttributes.code: String?
    get() = native.code as? String
    set(value) { native.code = value }
actual inline var FutureElementAttributes.colSpan: Int?
    get() = native.colSpan as? Int
    set(value) { native.colSpan = value }
actual inline var FutureElementAttributes.color: String?
    get() = native.color as? String
    set(value) { native.color = value }
actual inline var FutureElementAttributes.cols: Int?
    get() = native.cols as? Int
    set(value) { native.cols = value }
actual inline var FutureElementAttributes.columnCount: String?
    get() = native.columnCount as? String
    set(value) { native.columnCount = value }
actual inline var FutureElementAttributes.columnFill: String?
    get() = native.columnFill as? String
    set(value) { native.columnFill = value }
actual inline var FutureElementAttributes.columnGap: String?
    get() = native.columnGap as? String
    set(value) { native.columnGap = value }
actual inline var FutureElementAttributes.columnRule: String?
    get() = native.columnRule as? String
    set(value) { native.columnRule = value }
actual inline var FutureElementAttributes.columnRuleColor: String?
    get() = native.columnRuleColor as? String
    set(value) { native.columnRuleColor = value }
actual inline var FutureElementAttributes.columnRuleStyle: String?
    get() = native.columnRuleStyle as? String
    set(value) { native.columnRuleStyle = value }
actual inline var FutureElementAttributes.columnRuleWidth: String?
    get() = native.columnRuleWidth as? String
    set(value) { native.columnRuleWidth = value }
actual inline var FutureElementAttributes.columnSpan: String?
    get() = native.columnSpan as? String
    set(value) { native.columnSpan = value }
actual inline var FutureElementAttributes.columnWidth: String?
    get() = native.columnWidth as? String
    set(value) { native.columnWidth = value }
actual inline var FutureElementAttributes.columns: String?
    get() = native.columns as? String
    set(value) { native.columns = value }
actual inline var FutureElementAttributes.content: String?
    get() = native.content as? String
    set(value) { native.content = value }
actual inline var FutureElementAttributes.controls: Boolean?
    get() = native.controls as? Boolean
    set(value) { native.controls = value }
actual inline var FutureElementAttributes.coords: String?
    get() = native.coords as? String
    set(value) { native.coords = value }
actual inline var FutureElementAttributes.counterIncrement: String?
    get() = native.counterIncrement as? String
    set(value) { native.counterIncrement = value }
actual inline var FutureElementAttributes.counterReset: String?
    get() = native.counterReset as? String
    set(value) { native.counterReset = value }
actual inline var FutureElementAttributes.crossOrigin: String?
    get() = native.crossOrigin as? String
    set(value) { native.crossOrigin = value }
actual inline var FutureElementAttributes.csp: String?
    get() = native.csp as? String
    set(value) { native.csp = value }
actual inline var FutureElementAttributes.cssFloat: String?
    get() = native.cssFloat as? String
    set(value) { native.cssFloat = value }
actual inline var FutureElementAttributes.cssText: String?
    get() = native.cssText as? String
    set(value) { native.cssText = value }
actual inline var FutureElementAttributes.cursor: String?
    get() = native.cursor as? String
    set(value) { native.cursor = value }
actual inline var FutureElementAttributes.data: String?
    get() = native.data as? String
    set(value) { native.data = value }
actual inline var FutureElementAttributes.dateTime: String?
    get() = native.dateTime as? String
    set(value) { native.dateTime = value }
actual inline var FutureElementAttributes.default: Boolean?
    get() = native.default as? Boolean
    set(value) { native.default = value }
actual inline var FutureElementAttributes.defer: Boolean?
    get() = native.defer as? Boolean
    set(value) { native.defer = value }
actual inline var FutureElementAttributes.dir: String?
    get() = native.dir as? String
    set(value) { native.dir = value }
actual inline var FutureElementAttributes.dirName: String?
    get() = native.dirName as? String
    set(value) { native.dirName = value }
actual inline var FutureElementAttributes.direction: String?
    get() = native.direction as? String
    set(value) { native.direction = value }
actual inline var FutureElementAttributes.disabled: Boolean?
    get() = native.disabled as? Boolean
    set(value) { native.disabled = value }
actual inline var FutureElementAttributes.display: String?
    get() = native.display as? String
    set(value) { native.display = value }
actual inline var FutureElementAttributes.download: String?
    get() = native.download as? String
    set(value) { native.download = value }
actual inline var FutureElementAttributes.draggable: Boolean?
    get() = native.draggable as? Boolean
    set(value) { native.draggable = value }
actual inline var FutureElementAttributes.emptyCells: String?
    get() = native.emptyCells as? String
    set(value) { native.emptyCells = value }
actual inline var FutureElementAttributes.enctype: String?
    get() = native.enctype as? String
    set(value) { native.enctype = value }
actual inline var FutureElementAttributes.filter: String?
    get() = native.filter as? String
    set(value) { native.filter = value }
actual inline var FutureElementAttributes.flex: String?
    get() = native.flex as? String
    set(value) { native.flex = value }
actual inline var FutureElementAttributes.flexBasis: String?
    get() = native.flexBasis as? String
    set(value) { native.flexBasis = value }
actual inline var FutureElementAttributes.flexDirection: String?
    get() = native.flexDirection as? String
    set(value) { native.flexDirection = value }
actual inline var FutureElementAttributes.flexFlow: String?
    get() = native.flexFlow as? String
    set(value) { native.flexFlow = value }
actual inline var FutureElementAttributes.flexGrow: String?
    get() = native.flexGrow as? String
    set(value) { native.flexGrow = value }
actual inline var FutureElementAttributes.flexShrink: String?
    get() = native.flexShrink as? String
    set(value) { native.flexShrink = value }
actual inline var FutureElementAttributes.flexWrap: String?
    get() = native.flexWrap as? String
    set(value) { native.flexWrap = value }
actual inline var FutureElementAttributes.font: String?
    get() = native.font as? String
    set(value) { native.font = value }
actual inline var FutureElementAttributes.fontFamily: String?
    get() = native.fontFamily as? String
    set(value) { native.fontFamily = value }
actual inline var FutureElementAttributes.fontFeatureSettings: String?
    get() = native.fontFeatureSettings as? String
    set(value) { native.fontFeatureSettings = value }
actual inline var FutureElementAttributes.fontKerning: String?
    get() = native.fontKerning as? String
    set(value) { native.fontKerning = value }
actual inline var FutureElementAttributes.fontLanguageOverride: String?
    get() = native.fontLanguageOverride as? String
    set(value) { native.fontLanguageOverride = value }
actual inline var FutureElementAttributes.fontSize: String?
    get() = native.fontSize as? String
    set(value) { native.fontSize = value }
actual inline var FutureElementAttributes.fontSizeAdjust: String?
    get() = native.fontSizeAdjust as? String
    set(value) { native.fontSizeAdjust = value }
actual inline var FutureElementAttributes.fontStretch: String?
    get() = native.fontStretch as? String
    set(value) { native.fontStretch = value }
actual inline var FutureElementAttributes.fontStyle: String?
    get() = native.fontStyle as? String
    set(value) { native.fontStyle = value }
actual inline var FutureElementAttributes.fontSynthesis: String?
    get() = native.fontSynthesis as? String
    set(value) { native.fontSynthesis = value }
actual inline var FutureElementAttributes.fontVariant: String?
    get() = native.fontVariant as? String
    set(value) { native.fontVariant = value }
actual inline var FutureElementAttributes.fontVariantAlternates: String?
    get() = native.fontVariantAlternates as? String
    set(value) { native.fontVariantAlternates = value }
actual inline var FutureElementAttributes.fontVariantCaps: String?
    get() = native.fontVariantCaps as? String
    set(value) { native.fontVariantCaps = value }
actual inline var FutureElementAttributes.fontVariantEastAsian: String?
    get() = native.fontVariantEastAsian as? String
    set(value) { native.fontVariantEastAsian = value }
actual inline var FutureElementAttributes.fontVariantLigatures: String?
    get() = native.fontVariantLigatures as? String
    set(value) { native.fontVariantLigatures = value }
actual inline var FutureElementAttributes.fontVariantNumeric: String?
    get() = native.fontVariantNumeric as? String
    set(value) { native.fontVariantNumeric = value }
actual inline var FutureElementAttributes.fontVariantPosition: String?
    get() = native.fontVariantPosition as? String
    set(value) { native.fontVariantPosition = value }
actual inline var FutureElementAttributes.fontWeight: String?
    get() = native.fontWeight as? String
    set(value) { native.fontWeight = value }
actual inline var FutureElementAttributes.form: String?
    get() = native.form as? String
    set(value) { native.form = value }
actual inline var FutureElementAttributes.formAction: String?
    get() = native.formAction as? String
    set(value) { native.formAction = value }
actual inline var FutureElementAttributes.formEnctype: String?
    get() = native.formEnctype as? String
    set(value) { native.formEnctype = value }
actual inline var FutureElementAttributes.formMethod: String?
    get() = native.formMethod as? String
    set(value) { native.formMethod = value }
actual inline var FutureElementAttributes.formNoValidate: Boolean?
    get() = native.formNoValidate as? Boolean
    set(value) { native.formNoValidate = value }
actual inline var FutureElementAttributes.formTarget: String?
    get() = native.formTarget as? String
    set(value) { native.formTarget = value }
actual inline var FutureElementAttributes.hangingPunctuation: String?
    get() = native.hangingPunctuation as? String
    set(value) { native.hangingPunctuation = value }
actual inline var FutureElementAttributes.headers: String?
    get() = native.headers as? String
    set(value) { native.headers = value }
actual inline var FutureElementAttributes.heightInt: Int?
    get() = native.height as? Int
    set(value) { native.height = value }
actual inline var FutureElementAttributes.heightString: String?
    get() = native.height as? String
    set(value) { native.height = value }
actual inline var FutureElementAttributes.hidden: Boolean?
    get() = native.hidden as? Boolean
    set(value) { native.hidden = value }
actual inline var FutureElementAttributes.high: Double?
    get() = native.high as? Double
    set(value) { native.high = value }
actual inline var FutureElementAttributes.href: String?
    get() = native.href as? String
    set(value) { native.href = value }
actual inline var FutureElementAttributes.hreflang: String?
    get() = native.hreflang as? String
    set(value) { native.hreflang = value }
actual inline var FutureElementAttributes.htmlFor: String?
    get() = native.htmlFor as? String
    set(value) { native.htmlFor = value }
actual inline var FutureElementAttributes.httpEquiv: String?
    get() = native.httpEquiv as? String
    set(value) { native.httpEquiv = value }
actual inline var FutureElementAttributes.hyphens: String?
    get() = native.hyphens as? String
    set(value) { native.hyphens = value }
actual inline var FutureElementAttributes.id: String?
    get() = native.id as? String
    set(value) { native.id = value }
actual inline var FutureElementAttributes.imageOrientation: String?
    get() = native.imageOrientation as? String
    set(value) { native.imageOrientation = value }
actual inline var FutureElementAttributes.imageRendering: String?
    get() = native.imageRendering as? String
    set(value) { native.imageRendering = value }
actual inline var FutureElementAttributes.imageResolution: String?
    get() = native.imageResolution as? String
    set(value) { native.imageResolution = value }
actual inline var FutureElementAttributes.imeMode: String?
    get() = native.imeMode as? String
    set(value) { native.imeMode = value }
actual inline var FutureElementAttributes.inputMode: String?
    get() = native.inputMode as? String
    set(value) { native.inputMode = value }
actual inline var FutureElementAttributes.integrity: String?
    get() = native.integrity as? String
    set(value) { native.integrity = value }
actual inline var FutureElementAttributes.isMap: Boolean?
    get() = native.isMap as? Boolean
    set(value) { native.isMap = value }
actual inline var FutureElementAttributes.justifyContent: String?
    get() = native.justifyContent as? String
    set(value) { native.justifyContent = value }
actual inline var FutureElementAttributes.keytype: String?
    get() = native.keytype as? String
    set(value) { native.keytype = value }
actual inline var FutureElementAttributes.kind: String?
    get() = native.kind as? String
    set(value) { native.kind = value }
actual inline var FutureElementAttributes.label: String?
    get() = native.label as? String
    set(value) { native.label = value }
actual inline var FutureElementAttributes.lang: String?
    get() = native.lang as? String
    set(value) { native.lang = value }
actual inline var FutureElementAttributes.left: String?
    get() = native.left as? String
    set(value) { native.left = value }
actual inline var FutureElementAttributes.letterSpacing: String?
    get() = native.letterSpacing as? String
    set(value) { native.letterSpacing = value }
actual inline var FutureElementAttributes.lineBreak: String?
    get() = native.lineBreak as? String
    set(value) { native.lineBreak = value }
actual inline var FutureElementAttributes.lineHeight: String?
    get() = native.lineHeight as? String
    set(value) { native.lineHeight = value }
actual inline var FutureElementAttributes.list: String?
    get() = native.list as? String
    set(value) { native.list = value }
actual inline var FutureElementAttributes.listStyle: String?
    get() = native.listStyle as? String
    set(value) { native.listStyle = value }
actual inline var FutureElementAttributes.listStyleImage: String?
    get() = native.listStyleImage as? String
    set(value) { native.listStyleImage = value }
actual inline var FutureElementAttributes.listStylePosition: String?
    get() = native.listStylePosition as? String
    set(value) { native.listStylePosition = value }
actual inline var FutureElementAttributes.listStyleType: String?
    get() = native.listStyleType as? String
    set(value) { native.listStyleType = value }
actual inline var FutureElementAttributes.loading: String?
    get() = native.loading as? String
    set(value) { native.loading = value }
actual inline var FutureElementAttributes.loopBoolean: Boolean?
    get() = native.loop as? Boolean
    set(value) { native.loop = value }
actual inline var FutureElementAttributes.loopInt: Int?
    get() = native.loop as? Int
    set(value) { native.loop = value }
actual inline var FutureElementAttributes.low: Double?
    get() = native.low as? Double
    set(value) { native.low = value }
actual inline var FutureElementAttributes.margin: String?
    get() = native.margin as? String
    set(value) { native.margin = value }
actual inline var FutureElementAttributes.marginBottom: String?
    get() = native.marginBottom as? String
    set(value) { native.marginBottom = value }
actual inline var FutureElementAttributes.marginLeft: String?
    get() = native.marginLeft as? String
    set(value) { native.marginLeft = value }
actual inline var FutureElementAttributes.marginRight: String?
    get() = native.marginRight as? String
    set(value) { native.marginRight = value }
actual inline var FutureElementAttributes.marginTop: String?
    get() = native.marginTop as? String
    set(value) { native.marginTop = value }
actual inline var FutureElementAttributes.mark: String?
    get() = native.mark as? String
    set(value) { native.mark = value }
actual inline var FutureElementAttributes.markAfter: String?
    get() = native.markAfter as? String
    set(value) { native.markAfter = value }
actual inline var FutureElementAttributes.markBefore: String?
    get() = native.markBefore as? String
    set(value) { native.markBefore = value }
actual inline var FutureElementAttributes.marks: String?
    get() = native.marks as? String
    set(value) { native.marks = value }
actual inline var FutureElementAttributes.marqueeDirection: String?
    get() = native.marqueeDirection as? String
    set(value) { native.marqueeDirection = value }
actual inline var FutureElementAttributes.marqueePlayCount: String?
    get() = native.marqueePlayCount as? String
    set(value) { native.marqueePlayCount = value }
actual inline var FutureElementAttributes.marqueeSpeed: String?
    get() = native.marqueeSpeed as? String
    set(value) { native.marqueeSpeed = value }
actual inline var FutureElementAttributes.marqueeStyle: String?
    get() = native.marqueeStyle as? String
    set(value) { native.marqueeStyle = value }
actual inline var FutureElementAttributes.mask: String?
    get() = native.mask as? String
    set(value) { native.mask = value }
actual inline var FutureElementAttributes.maskType: String?
    get() = native.maskType as? String
    set(value) { native.maskType = value }
actual inline var FutureElementAttributes.maxDouble: Double?
    get() = native.max as? Double
    set(value) { native.max = value }
actual inline var FutureElementAttributes.maxHeight: String?
    get() = native.maxHeight as? String
    set(value) { native.maxHeight = value }
actual inline var FutureElementAttributes.maxLength: Int?
    get() = native.maxLength as? Int
    set(value) { native.maxLength = value }
actual inline var FutureElementAttributes.maxString: String?
    get() = native.max as? String
    set(value) { native.max = value }
actual inline var FutureElementAttributes.maxWidth: String?
    get() = native.maxWidth as? String
    set(value) { native.maxWidth = value }
actual inline var FutureElementAttributes.media: String?
    get() = native.media as? String
    set(value) { native.media = value }
actual inline var FutureElementAttributes.method: String?
    get() = native.method as? String
    set(value) { native.method = value }
actual inline var FutureElementAttributes.minDouble: Double?
    get() = native.min as? Double
    set(value) { native.min = value }
actual inline var FutureElementAttributes.minHeight: String?
    get() = native.minHeight as? String
    set(value) { native.minHeight = value }
actual inline var FutureElementAttributes.minLength: Int?
    get() = native.minLength as? Int
    set(value) { native.minLength = value }
actual inline var FutureElementAttributes.minString: String?
    get() = native.min as? String
    set(value) { native.min = value }
actual inline var FutureElementAttributes.minWidth: String?
    get() = native.minWidth as? String
    set(value) { native.minWidth = value }
actual inline var FutureElementAttributes.multiple: Boolean?
    get() = native.multiple as? Boolean
    set(value) { native.multiple = value }
actual inline var FutureElementAttributes.muted: Boolean?
    get() = native.muted as? Boolean
    set(value) { native.muted = value }
actual inline var FutureElementAttributes.name: String?
    get() = native.name as? String
    set(value) { native.name = value }
actual inline var FutureElementAttributes.navDown: String?
    get() = native.navDown as? String
    set(value) { native.navDown = value }
actual inline var FutureElementAttributes.navIndex: String?
    get() = native.navIndex as? String
    set(value) { native.navIndex = value }
actual inline var FutureElementAttributes.navLeft: String?
    get() = native.navLeft as? String
    set(value) { native.navLeft = value }
actual inline var FutureElementAttributes.navRight: String?
    get() = native.navRight as? String
    set(value) { native.navRight = value }
actual inline var FutureElementAttributes.navUp: String?
    get() = native.navUp as? String
    set(value) { native.navUp = value }
actual inline var FutureElementAttributes.noValidate: Boolean?
    get() = native.noValidate as? Boolean
    set(value) { native.noValidate = value }
actual inline var FutureElementAttributes.nodeValue: String?
    get() = native.nodeValue as? String
    set(value) { native.nodeValue = value }
actual inline var FutureElementAttributes.objectFit: String?
    get() = native.objectFit as? String
    set(value) { native.objectFit = value }
actual inline var FutureElementAttributes.objectPosition: String?
    get() = native.objectPosition as? String
    set(value) { native.objectPosition = value }
actual inline var FutureElementAttributes.opacity: String?
    get() = native.opacity as? String
    set(value) { native.opacity = value }
actual inline var FutureElementAttributes.open: Boolean?
    get() = native.open as? Boolean
    set(value) { native.open = value }
actual inline var FutureElementAttributes.optimum: Double?
    get() = native.optimum as? Double
    set(value) { native.optimum = value }
actual inline var FutureElementAttributes.order: String?
    get() = native.order as? String
    set(value) { native.order = value }
actual inline var FutureElementAttributes.orphans: String?
    get() = native.orphans as? String
    set(value) { native.orphans = value }
actual inline var FutureElementAttributes.outline: String?
    get() = native.outline as? String
    set(value) { native.outline = value }
actual inline var FutureElementAttributes.outlineColor: String?
    get() = native.outlineColor as? String
    set(value) { native.outlineColor = value }
actual inline var FutureElementAttributes.outlineOffset: String?
    get() = native.outlineOffset as? String
    set(value) { native.outlineOffset = value }
actual inline var FutureElementAttributes.outlineStyle: String?
    get() = native.outlineStyle as? String
    set(value) { native.outlineStyle = value }
actual inline var FutureElementAttributes.outlineWidth: String?
    get() = native.outlineWidth as? String
    set(value) { native.outlineWidth = value }
actual inline var FutureElementAttributes.overflowWrap: String?
    get() = native.overflowWrap as? String
    set(value) { native.overflowWrap = value }
actual inline var FutureElementAttributes.overflowX: String?
    get() = native.overflowX as? String
    set(value) { native.overflowX = value }
actual inline var FutureElementAttributes.overflowY: String?
    get() = native.overflowY as? String
    set(value) { native.overflowY = value }
actual inline var FutureElementAttributes.padding: String?
    get() = native.padding as? String
    set(value) { native.padding = value }
actual inline var FutureElementAttributes.paddingBottom: String?
    get() = native.paddingBottom as? String
    set(value) { native.paddingBottom = value }
actual inline var FutureElementAttributes.paddingLeft: String?
    get() = native.paddingLeft as? String
    set(value) { native.paddingLeft = value }
actual inline var FutureElementAttributes.paddingRight: String?
    get() = native.paddingRight as? String
    set(value) { native.paddingRight = value }
actual inline var FutureElementAttributes.paddingTop: String?
    get() = native.paddingTop as? String
    set(value) { native.paddingTop = value }
actual inline var FutureElementAttributes.pageBreakAfter: String?
    get() = native.pageBreakAfter as? String
    set(value) { native.pageBreakAfter = value }
actual inline var FutureElementAttributes.pageBreakBefore: String?
    get() = native.pageBreakBefore as? String
    set(value) { native.pageBreakBefore = value }
actual inline var FutureElementAttributes.pageBreakInside: String?
    get() = native.pageBreakInside as? String
    set(value) { native.pageBreakInside = value }
actual inline var FutureElementAttributes.pattern: String?
    get() = native.pattern as? String
    set(value) { native.pattern = value }
actual inline var FutureElementAttributes.perspective: String?
    get() = native.perspective as? String
    set(value) { native.perspective = value }
actual inline var FutureElementAttributes.perspectiveOrigin: String?
    get() = native.perspectiveOrigin as? String
    set(value) { native.perspectiveOrigin = value }
actual inline var FutureElementAttributes.phonemes: String?
    get() = native.phonemes as? String
    set(value) { native.phonemes = value }
actual inline var FutureElementAttributes.ping: String?
    get() = native.ping as? String
    set(value) { native.ping = value }
actual inline var FutureElementAttributes.placeholder: String?
    get() = native.placeholder as? String
    set(value) { native.placeholder = value }
actual inline var FutureElementAttributes.playsInline: Boolean?
    get() = native.playsInline as? Boolean
    set(value) { native.playsInline = value }
actual inline var FutureElementAttributes.position: String?
    get() = native.position as? String
    set(value) { native.position = value }
actual inline var FutureElementAttributes.poster: String?
    get() = native.poster as? String
    set(value) { native.poster = value }
actual inline var FutureElementAttributes.preload: String?
    get() = native.preload as? String
    set(value) { native.preload = value }
actual inline var FutureElementAttributes.quotes: String?
    get() = native.quotes as? String
    set(value) { native.quotes = value }
actual inline var FutureElementAttributes.readOnly: Boolean?
    get() = native.readOnly as? Boolean
    set(value) { native.readOnly = value }
actual inline var FutureElementAttributes.referrerPolicy: String?
    get() = native.referrerPolicy as? String
    set(value) { native.referrerPolicy = value }
actual inline var FutureElementAttributes.referrerpolicy: String?
    get() = native.referrerpolicy as? String
    set(value) { native.referrerpolicy = value }
actual inline var FutureElementAttributes.rel: String?
    get() = native.rel as? String
    set(value) { native.rel = value }
actual inline var FutureElementAttributes.required: Boolean?
    get() = native.required as? Boolean
    set(value) { native.required = value }
actual inline var FutureElementAttributes.resize: String?
    get() = native.resize as? String
    set(value) { native.resize = value }
actual inline var FutureElementAttributes.rest: String?
    get() = native.rest as? String
    set(value) { native.rest = value }
actual inline var FutureElementAttributes.restAfter: String?
    get() = native.restAfter as? String
    set(value) { native.restAfter = value }
actual inline var FutureElementAttributes.restBefore: String?
    get() = native.restBefore as? String
    set(value) { native.restBefore = value }
actual inline var FutureElementAttributes.reversed: Boolean?
    get() = native.reversed as? Boolean
    set(value) { native.reversed = value }
actual inline var FutureElementAttributes.right: String?
    get() = native.right as? String
    set(value) { native.right = value }
actual inline var FutureElementAttributes.rowSpan: Int?
    get() = native.rowSpan as? Int
    set(value) { native.rowSpan = value }
actual inline var FutureElementAttributes.rows: Int?
    get() = native.rows as? Int
    set(value) { native.rows = value }
actual inline var FutureElementAttributes.sandbox: String?
    get() = native.sandbox as? String
    set(value) { native.sandbox = value }
actual inline var FutureElementAttributes.selected: Boolean?
    get() = native.selected as? Boolean
    set(value) { native.selected = value }
actual inline var FutureElementAttributes.shape: String?
    get() = native.shape as? String
    set(value) { native.shape = value }
actual inline var FutureElementAttributes.size: Int?
    get() = native.size as? Int
    set(value) { native.size = value }
actual inline var FutureElementAttributes.sizes: String?
    get() = native.sizes as? String
    set(value) { native.sizes = value }
actual inline var FutureElementAttributes.slot: String?
    get() = native.slot as? String
    set(value) { native.slot = value }
actual inline var FutureElementAttributes.span: Int?
    get() = native.span as? Int
    set(value) { native.span = value }
actual inline var FutureElementAttributes.spellcheck: Boolean?
    get() = native.spellcheck as? Boolean
    set(value) { native.spellcheck = value }
actual inline var FutureElementAttributes.src: String?
    get() = native.src as? String
    set(value) { native.src = value }
actual inline var FutureElementAttributes.srcdoc: String?
    get() = native.srcdoc as? String
    set(value) { native.srcdoc = value }
actual inline var FutureElementAttributes.srclang: String?
    get() = native.srclang as? String
    set(value) { native.srclang = value }
actual inline var FutureElementAttributes.srcset: String?
    get() = native.srcset as? String
    set(value) { native.srcset = value }
actual inline var FutureElementAttributes.start: Int?
    get() = native.start as? Int
    set(value) { native.start = value }
actual inline var FutureElementAttributes.step: String?
    get() = native.step as? String
    set(value) { native.step = value }
actual inline var FutureElementAttributes.summary: String?
    get() = native.summary as? String
    set(value) { native.summary = value }
actual inline var FutureElementAttributes.tabIndex: Int?
    get() = native.tabIndex as? Int
    set(value) { native.tabIndex = value }
actual inline var FutureElementAttributes.tabSize: String?
    get() = native.tabSize as? String
    set(value) { native.tabSize = value }
actual inline var FutureElementAttributes.tableLayout: String?
    get() = native.tableLayout as? String
    set(value) { native.tableLayout = value }
actual inline var FutureElementAttributes.target: String?
    get() = native.target as? String
    set(value) { native.target = value }
actual inline var FutureElementAttributes.textAlign: String?
    get() = native.textAlign as? String
    set(value) { native.textAlign = value }
actual inline var FutureElementAttributes.textAlignLast: String?
    get() = native.textAlignLast as? String
    set(value) { native.textAlignLast = value }
actual inline var FutureElementAttributes.textCombineUpright: String?
    get() = native.textCombineUpright as? String
    set(value) { native.textCombineUpright = value }
actual inline var FutureElementAttributes.textDecoration: String?
    get() = native.textDecoration as? String
    set(value) { native.textDecoration = value }
actual inline var FutureElementAttributes.textDecorationColor: String?
    get() = native.textDecorationColor as? String
    set(value) { native.textDecorationColor = value }
actual inline var FutureElementAttributes.textDecorationLine: String?
    get() = native.textDecorationLine as? String
    set(value) { native.textDecorationLine = value }
actual inline var FutureElementAttributes.textDecorationStyle: String?
    get() = native.textDecorationStyle as? String
    set(value) { native.textDecorationStyle = value }
actual inline var FutureElementAttributes.textIndent: String?
    get() = native.textIndent as? String
    set(value) { native.textIndent = value }
actual inline var FutureElementAttributes.textJustify: String?
    get() = native.textJustify as? String
    set(value) { native.textJustify = value }
actual inline var FutureElementAttributes.textOrientation: String?
    get() = native.textOrientation as? String
    set(value) { native.textOrientation = value }
actual inline var FutureElementAttributes.textOverflow: String?
    get() = native.textOverflow as? String
    set(value) { native.textOverflow = value }
actual inline var FutureElementAttributes.textShadow: String?
    get() = native.textShadow as? String
    set(value) { native.textShadow = value }
actual inline var FutureElementAttributes.textTransform: String?
    get() = native.textTransform as? String
    set(value) { native.textTransform = value }
actual inline var FutureElementAttributes.textUnderlinePosition: String?
    get() = native.textUnderlinePosition as? String
    set(value) { native.textUnderlinePosition = value }
actual inline var FutureElementAttributes.title: String?
    get() = native.title as? String
    set(value) { native.title = value }
actual inline var FutureElementAttributes.top: String?
    get() = native.top as? String
    set(value) { native.top = value }
actual inline var FutureElementAttributes.transform: String?
    get() = native.transform as? String
    set(value) { native.transform = value }
actual inline var FutureElementAttributes.transformOrigin: String?
    get() = native.transformOrigin as? String
    set(value) { native.transformOrigin = value }
actual inline var FutureElementAttributes.transformStyle: String?
    get() = native.transformStyle as? String
    set(value) { native.transformStyle = value }
actual inline var FutureElementAttributes.transition: String?
    get() = native.transition as? String
    set(value) { native.transition = value }
actual inline var FutureElementAttributes.transitionDelay: String?
    get() = native.transitionDelay as? String
    set(value) { native.transitionDelay = value }
actual inline var FutureElementAttributes.transitionDuration: String?
    get() = native.transitionDuration as? String
    set(value) { native.transitionDuration = value }
actual inline var FutureElementAttributes.transitionProperty: String?
    get() = native.transitionProperty as? String
    set(value) { native.transitionProperty = value }
actual inline var FutureElementAttributes.transitionTimingFunction: String?
    get() = native.transitionTimingFunction as? String
    set(value) { native.transitionTimingFunction = value }
actual inline var FutureElementAttributes.translate: Boolean?
    get() = native.translate as? Boolean
    set(value) { native.translate = value }
actual inline var FutureElementAttributes.type: String?
    get() = native.type as? String
    set(value) { native.type = value }
actual inline var FutureElementAttributes.unicodeBidi: String?
    get() = native.unicodeBidi as? String
    set(value) { native.unicodeBidi = value }
actual inline var FutureElementAttributes.useMap: String?
    get() = native.useMap as? String
    set(value) { native.useMap = value }
actual inline var FutureElementAttributes.valueDouble: Double?
    get() = native.value as? Double
    set(value) { native.value = value }
actual inline var FutureElementAttributes.valueInt: Int?
    get() = native.value as? Int
    set(value) { native.value = value }
actual inline var FutureElementAttributes.valueString: String?
    get() = native.value as? String
    set(value) { native.value = value }
actual inline var FutureElementAttributes.verticalAlign: String?
    get() = native.verticalAlign as? String
    set(value) { native.verticalAlign = value }
actual inline var FutureElementAttributes.visibility: String?
    get() = native.visibility as? String
    set(value) { native.visibility = value }
actual inline var FutureElementAttributes.voiceBalance: String?
    get() = native.voiceBalance as? String
    set(value) { native.voiceBalance = value }
actual inline var FutureElementAttributes.voiceDuration: String?
    get() = native.voiceDuration as? String
    set(value) { native.voiceDuration = value }
actual inline var FutureElementAttributes.voicePitch: String?
    get() = native.voicePitch as? String
    set(value) { native.voicePitch = value }
actual inline var FutureElementAttributes.voicePitchRange: String?
    get() = native.voicePitchRange as? String
    set(value) { native.voicePitchRange = value }
actual inline var FutureElementAttributes.voiceRate: String?
    get() = native.voiceRate as? String
    set(value) { native.voiceRate = value }
actual inline var FutureElementAttributes.voiceStress: String?
    get() = native.voiceStress as? String
    set(value) { native.voiceStress = value }
actual inline var FutureElementAttributes.voiceVolume: String?
    get() = native.voiceVolume as? String
    set(value) { native.voiceVolume = value }
actual inline var FutureElementAttributes.whiteSpace: String?
    get() = native.whiteSpace as? String
    set(value) { native.whiteSpace = value }
actual inline var FutureElementAttributes.widows: String?
    get() = native.widows as? String
    set(value) { native.widows = value }
actual inline var FutureElementAttributes.widthInt: Int?
    get() = native.width as? Int
    set(value) { native.width = value }
actual inline var FutureElementAttributes.widthString: String?
    get() = native.width as? String
    set(value) { native.width = value }
actual inline var FutureElementAttributes.wordBreak: String?
    get() = native.wordBreak as? String
    set(value) { native.wordBreak = value }
actual inline var FutureElementAttributes.wordSpacing: String?
    get() = native.wordSpacing as? String
    set(value) { native.wordSpacing = value }
actual inline var FutureElementAttributes.wordWrap: String?
    get() = native.wordWrap as? String
    set(value) { native.wordWrap = value }
actual inline var FutureElementAttributes.wrap: String?
    get() = native.wrap as? String
    set(value) { native.wrap = value }
actual inline var FutureElementAttributes.writingMode: String?
    get() = native.writingMode as? String
    set(value) { native.writingMode = value }
actual inline var FutureElementAttributes.zIndex: String?
    get() = native.zIndex as? String
    set(value) { native.zIndex = value }